import { createSelector } from 'reselect';

import { RootState } from 'redux/store';

const logState = (state: RootState) => state.logs;
export const logsSelector = createSelector(logState, (state) => state.data);
export const logsStatusSelector = createSelector(logState, (state) => state.status);
export const totalLogSelector = createSelector(logState, (state) => state.total);
